import React, { useEffect } from 'react'
import ServicesComp from '../../components/ServicesComp/ServicesComp'
import { Container } from 'react-bootstrap'
import NewsAndUpdates from '../../components/homepage/NewsAndUpdates/NewsAndUpdates'
import ServicesBanner from '../../components/ServicesComp/ServicesBanner/ServicesBanner'

const ServicesPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <Container fluid={true} className="p-0">
        <ServicesBanner />
        <ServicesComp />
        <NewsAndUpdates />
    </Container>
  )
}

export default ServicesPage